import i18n from 'i18next';
/**
 * "내가 쏠게요" 결제 표시 유틸 — totalAmount=0 으로 저장된 treat 결제를
 * 재미있는 문구로 보여주기 위한 헬퍼.
 *
 * 동일 paymentId 는 항상 같은 문구가 나오도록 deterministic 해시 사용.
 */

// 풀은 현재 언어로 — 언어 변경 시 reload 되므로 모듈 평가로 충분.
const getTreatPhrases = (): string[] => {
    const p = i18n.t('treat.phrases', { returnObjects: true });
    return Array.isArray(p) ? p as string[] : ['\uD1B5 \uD070 \uD55C \uD134'];
};

const hashString = (s: string): number => {
    let h = 0;
    for (let i = 0; i < s.length; i++) {
        h = ((h << 5) - h) + s.charCodeAt(i);
        h |= 0;
    }
    return Math.abs(h);
};

/** treat 일 때 재밌는 문구, 아니면 숫자+원. */
export const formatPaymentAmount = (payment: { paymentId?: string | number; totalAmount?: number; isTreat?: boolean }): string => {
    if (payment.isTreat) {
        const seed = String(payment.paymentId || payment.totalAmount || Math.random());
        const phrases = getTreatPhrases();
        const phrase = phrases[hashString(seed) % phrases.length];
        return phrase;
    }
    return i18n.t('meetingFinished.amountWon', { amount: Number(payment.totalAmount || 0).toLocaleString('ko-KR') });
};

/** treat 결제인지 빠르게 체크 — 단순 alias */
export const isTreatPayment = (payment: { isTreat?: boolean }): boolean => !!payment.isTreat;

/** 배너 / 카드 강조용 fun 문구만 반환 */
export const pickTreatPhrase = (seed: string): string => {
    const phrases = getTreatPhrases();
    return phrases[hashString(seed) % phrases.length];
};
